var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { hexStringToBase64, WalletType } from '@usecapsule/web-sdk';
export function offRampSend(capsule_1, _a, setOnRampPurchase_1, _b) {
    return __awaiter(this, arguments, void 0, function* (capsule, { id: purchaseId, provider, walletId, walletType }, setOnRampPurchase, { assetQuantity, fiat, fiatQuantity, chainId, destinationAddress, contractAddress, testMode = false, }) {
        var _c;
        if (!purchaseId || !walletId || !walletType || !provider) {
            throw new Error('missing required fields');
        }
        const { tx, network, asset } = yield capsule.ctx.capsuleClient.generateOffRampTx(capsule.getUserId(), {
            walletId,
            walletType,
            provider,
            chainId,
            destinationAddress,
            contractAddress,
            testMode,
            assetQuantity,
        });
        let signature;
        switch (walletType) {
            case WalletType.EVM:
                signature = (_c = ((yield capsule.signTransaction(walletId, hexStringToBase64(tx), chainId)))) === null || _c === void 0 ? void 0 : _c.signature;
                break;
            default:
                throw new Error(`unsupported wallet type: ${walletType}`);
        }
        const { txHash } = yield capsule.ctx.capsuleClient.sendOffRampTx(capsule.getUserId(), {
            tx,
            signature: walletType === 'EVM' ? `0x${signature}` : signature,
            network,
            walletId,
            walletType,
        });
        const updated = yield capsule.ctx.capsuleClient.updateOnRampPurchase({
            userId: capsule.getUserId(),
            walletId,
            purchaseId,
            updates: {
                fiat,
                fiatQuantity,
                assetQuantity,
                network,
                asset,
            },
        });
        setOnRampPurchase(updated);
        return txHash;
    });
}
